/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'

/**
 * 参照する Survey（アンケート集約）。SURVEYノードのみ設定・複数ノードで共有可（ADR-0011）
 * @nullable
 */
export type ScenarioNodeSurveyId = Cuid | null
